import { render, staticRenderFns } from "./VisualizarPcoWorkflowTempComponent.vue?vue&type=template&id=04d3dcf2&scoped=true"
import script from "./VisualizarPcoWorkflowTempComponent.vue?vue&type=script&lang=js"
export * from "./VisualizarPcoWorkflowTempComponent.vue?vue&type=script&lang=js"
import style0 from "./VisualizarPcoWorkflowTempComponent.vue?vue&type=style&index=0&id=04d3dcf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d3dcf2",
  null
  
)

export default component.exports